import { defineBlocksWithJsonArray } from 'blockly/core';

const LOOP_STYLE = 'loop_blocks';

/**
 * Beginner Loops blocks.
 * Existing Repeat (`controls_repeat_ext`) and Forever (`beginner_forever`) are unchanged.
 */
const loopBlockDefinitions = [
  {
    type: 'beginner_repeat_until',
    message0: 'repeat until %1 %2',
    args0: [
      { type: 'input_value', name: 'CONDITION', check: 'Boolean' },
      { type: 'input_statement', name: 'DO' },
    ],
    previousStatement: null,
    nextStatement: null,
    style: LOOP_STYLE,
    tooltip: 'Keeps doing the blocks inside until the condition becomes true.',
    helpUrl: '',
  },
  {
    type: 'beginner_break_loop',
    message0: 'break loop',
    previousStatement: null,
    nextStatement: null,
    style: LOOP_STYLE,
    tooltip: 'Stops the nearest repeat, forever, or repeat until.',
    helpUrl: '',
  },
];

export function registerBeginnerLoopBlocks(): void {
  defineBlocksWithJsonArray(loopBlockDefinitions);
}
